import React, { useEffect, useState } from "react";
import { endpoints } from "@/lib/api";
import { PageHeader, CTASection } from "@/components/site/Bits";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export default function FAQs() {
  const [faqs, setFaqs] = useState([]);
  useEffect(() => {
    endpoints.faqs().then(setFaqs).catch(() => {});
  }, []);

  return (
    <div data-testid="faqs-page">
      <PageHeader
        eyebrow="FAQs"
        title={["Considered", "answers."]}
        intro="Everything you might wish to know before your enquiry. For anything further, we are only an email away."
        testid="faqs-header"
      />

      <section className="aria-container pb-28 md:pb-40">
        <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
          {faqs.map((f, i) => (
            <AccordionItem key={f.id} value={`faq-${i}`} className="border-b border-aria-travertine">
              <AccordionTrigger className="py-8 text-left font-display text-2xl md:text-3xl text-aria-ink hover:no-underline">
                {f.question}
              </AccordionTrigger>
              <AccordionContent className="max-w-3xl pb-8 font-light text-base md:text-lg leading-relaxed text-aria-cocoa/80">
                {f.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </section>

      <CTASection />
    </div>
  );
}
